import { render, staticRenderFns } from "./ScreensView.vue?vue&type=template&id=3c78ec44&scoped=true"
import script from "./ScreensView.vue?vue&type=script&lang=js"
export * from "./ScreensView.vue?vue&type=script&lang=js"
import style0 from "./ScreensView.vue?vue&type=style&index=0&id=3c78ec44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c78ec44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c78ec44')) {
      api.createRecord('3c78ec44', component.options)
    } else {
      api.reload('3c78ec44', component.options)
    }
    module.hot.accept("./ScreensView.vue?vue&type=template&id=3c78ec44&scoped=true", function () {
      api.rerender('3c78ec44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/ScreensView.vue"
export default component.exports